import { RootState } from 'app/rootReducer'

export const carrierInvitesSelector = (
  state: RootState
): Record<number, CarrierInvite> => state.carrierInvites.invites

export const carrierInvitesIsLoadingSelector = (state: RootState): boolean =>
  state.carrierInvites.meta.isLoading

export const carriersInvitedSelector = (state: RootState) =>
  Object.values(state.carrierInvites.invitedCarriers)

export const carriersInvitedMapSelector = (state: RootState) =>
  state.carrierInvites.invitedCarriers

export const carrierInvitesMapSelector = (state: RootState) =>
  state.carrierInvites.invites
